import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=cc7020c8&shadow"
import script from "./offers.vue?vue&type=script&lang=js&shadow"
export * from "./offers.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports